export const size100 = "16px";
export const size200 = "24px";
export const size300 = "32px";
export const size375 = "44px";
export const size400 = "48px";
export const size500 = "64px";
export const size600 = "128px";
export const size700 = "256px";
export const size800 = "512px";